import { __rest, __assign, __spreadArray, __read } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useCalendarGrid } from 'react-aria';
import { getWeeksInMonth as $14e0f24ef4ac5c92$export$ccc1b2479e7dd654 } from '../../../external/@internationalized/date/dist/queries.mjs.js';
import dayjs from 'dayjs';
import styles from './CalendarGrid.module.scss.js';
import { CalendarCell } from './calendarCell/CalendarCell.js';

var CalendarGrid = function (_a) {
    var state = _a.state, grayOutPastDates = _a.grayOutPastDates, props = __rest(_a, ["state", "grayOutPastDates"]);
    var _b = useCalendarGrid(props, state), gridProps = _b.gridProps, headerProps = _b.headerProps, weekDays = _b.weekDays;
    var weeksInMonth = $14e0f24ef4ac5c92$export$ccc1b2479e7dd654(state.visibleRange.start, 'en');
    return (jsxs("table", __assign({ className: styles.calendarGrid }, gridProps, { children: [jsx("thead", __assign({}, headerProps, { children: jsx("tr", { children: weekDays.map(function (_day, index) { return (jsx("th", { children: dayjs().day(index).format('ddd') }, index)); }) }) })), jsx("tbody", { children: __spreadArray([], __read(new Array(weeksInMonth).keys()), false).map(function (weekIndex) { return (jsx("tr", { children: state
                        .getDatesInWeek(weekIndex)
                        .map(function (date, i) {
                        return date ? (jsx(CalendarCell, { grayOutPastDate: grayOutPastDates, state: state, date: date }, i)) : (jsx("td", {}, i));
                    }) }, weekIndex)); }) })] })));
};

export { CalendarGrid };
